import mitt from "mitt";
import { defineNuxtPlugin } from "nuxt/app";
export default defineNuxtPlugin(() => {
  const mitter = mitt();
  return {
    provide: {
      mitter
    }
  };
});
